import { createContext } from "react";
import request from "superagent";

export const ViewerContext = createContext(undefined);
export const DatasourceContext = createContext(request);
export const CacheContext = createContext(null);
export const ProgressContext = createContext(() => {});
export const FeaturesContext = createContext({});
